import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import gql from 'graphql-tag';
import { SidenavComponent } from "ng-uikit-pro-standard";
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { DescargarArchivoService } from 'src/app/services/descagar-desde-blob.service';
import { DocumentoNoTributarioService } from 'src/app/services/documento-no-tributario.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalResultadosConversionService } from 'src/app/services/modal-resultados-conversion.service';
import { SignalRMessageService } from "src/app/services/SignalRMessage.service";
import { SignalRService } from "src/app/services/SignalRNegotiate.service";
import { rol_operacionJoin } from 'src/app/shared/object/rol_operacionJoin.model';
import { usuario } from 'src/app/shared/object/usuario.model';
import { usuario_rol } from 'src/app/shared/object/usuario_rol.model';
import { AuthService } from "src/app/shared/services/auth.service";
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ENVIRONMENT_FUNCTIONS } from "src/environments/environment";
import { SecurityService } from "../../shared/services/security.service";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
  providers: [SecurityService, ValidadoresService],
})
export class NavigationComponent implements OnInit, OnDestroy {
  @ViewChild("sidenav", null) sidenav: ElementRef;
  @ViewChild('toggleButton', { static: true }) toggleButton: ElementRef;
  @ViewChild('menu', { static: true }) menu: ElementRef;

  clicked: boolean;

  @ViewChild("sidenav", null) sidenavr: SidenavComponent;
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private rutUsuario: number;
  private urlNegociador: string = "";
  private urlMensaje: string = "";
  nombre_usuario: string;
  codigo_rol: number;
  moduloMenu: rol_operacionJoin[];
  categoriasMenu: Array<any> = [];
  private client: GraphQLClient = null;
  listaMovimientos: Array<any> = [];
  countNotificaciones: number = 0;
  isMenuOpen = false;
  not_groupArr: any[] = [];
  private notificationSubscription: Subscription;

  // Utils
  private log: any;

  constructor(client: GraphQLClient,
    public authService: AuthService,
    public router: Router,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private signalRMessageService: SignalRMessageService,
    private signalRService: SignalRService,
    private renderer: Renderer2,
    private clog: ConsoleService,
    private descargarArchivoService: DescargarArchivoService,
    private documentoNoTributarioService: DocumentoNoTributarioService,
    private messageRendererService: MessageRendererService,
    private modalResultadosConversionService: ModalResultadosConversionService,
  ) {
    this.clicked = this.clicked === undefined ? false : true;
    this.client = client;
    this.log = this.clog.log('NAVEGADOR');
    this.renderer.listen('window', 'click', (e: Event) => {
      // console.log('click windows', this.toggleButton.nativeElement);
      // console.log('click windows', e.target);
      if (!this.isMenuOpen) return;
      const clickedInsideToggle = this.toggleButton.nativeElement && this.toggleButton.nativeElement.contains(e.target);
      const clickedInsideMenu = this.menu.nativeElement && this.menu.nativeElement.contains(e.target);
      if (clickedInsideToggle || clickedInsideMenu) return;

      this.closeDropdown();
      // if (this.countNotificaciones == 0 && this.isMenuOpen == true) {
      //   if (e.target !== this.toggleButton.nativeElement && e.target !== this.menu.nativeElement) {
      //     //this.isMenuOpen = false;
      //     //this.countNotificaciones = 0;
      //     this.closeDropdown()
      //   }
      // }
    });
  }

  ngOnInit() {
    let seEncuentraRut = this.accesolocalstorage.getRutUsuario()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    if (seEncuentraRut != null) {
      this.rutUsuario = this.accesolocalstorage.getRutUsuario();
      this.obtenerDatosUsuario(this.rutUsuario);
      this.obtenerUsuarioRol(this.rutUsuario);
      this.sendMessage();
    }
    this.getNotificacion();
  }

  ngOnDestroy() {
    // Limpiar la suscripción cuando el componente se destruya
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }

  toggleMenu(event?: any) {
    console.log('toggle menu', event);
    if (event) event.stopPropagation();

    const willOpen = !this.isMenuOpen;
    this.isMenuOpen = willOpen;
    console.log('toggle menu', this.isMenuOpen);
    if (!willOpen) {
      this.actualizarNotificaciones();
    }
  }


  hideSidenavAfterClick() {
    if (window.innerWidth <= 1440) {
      this.sidenavr.hide();
    }
  }

  async getNotificacion() {
    await this.signalRService.init();

    // Desuscribirse si ya existe una suscripción previa
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }

    this.notificationSubscription = this.signalRService.messages.pipe(
      // Filtrar mensajes vacíos o inválidos antes de procesarlos
      filter((message: any) => {
        if (!message) return false;
        const payload = typeof message === 'string' ? message : JSON.stringify(message);
        let items: any[] = [];
        try {
          items = JSON.parse(payload) || [];
        } catch {
          return false;
        }
        return items.length > 0;
      }),
      // Esperar 300ms antes de procesar para evitar actualizaciones múltiples muy rápidas
      debounceTime(300),
      // Solo procesar si el mensaje es diferente al anterior
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
    ).subscribe((message: any) => {
      // Normaliza el payload (string JSON esperado) y filtra por usuario
      const payload = typeof message === 'string' ? message : JSON.stringify(message);
      let items: any[] = [];
      try {
        items = JSON.parse(payload) || [];
      } catch {
        items = [];
      }

      console.log('NOTIFICACIONES RECIBIDAS', items);

      // Filtra por usuario y empresa
      const notificacionesFiltradas = items.filter(x =>
        x.rut_usuario == this.rutUsuario && x.rut_empresa == this.rutEmpresa
      );

      console.log('NOTIFICACIONES RECIBIDAS FILTRADAS', notificacionesFiltradas);

      // Solo actualizar si hay cambios reales en las notificaciones
      if (JSON.stringify(this.listaMovimientos) !== JSON.stringify(notificacionesFiltradas)) {
        this.listaMovimientos = notificacionesFiltradas;

        this.not_groupArr = this.listaMovimientos.reduce((r, { categoria_modulo_codigo }) => {
          if (!r.some((o) => o.categoria_modulo_codigo == categoria_modulo_codigo)) {
            r.push({
              categoria_modulo_codigo,
              categoria_nombre: this.listaMovimientos.find((x) => x.categoria_modulo_codigo == categoria_modulo_codigo).categoria_modulo_nombre,
              listanot_groupItem: this.listaMovimientos.filter((v) => v.categoria_modulo_codigo == categoria_modulo_codigo),
            });
          }
          return r;
        }, []);

        this.countNotificaciones = this.listaMovimientos.filter(x => x.estado_notificacion_codigo == 1).length;
        console.log('CONTADOR DE NOTIFICACIONES ACTUALIZADO:', this.countNotificaciones);
      }
    });
  }



  setClicked(val: boolean): void {
    this.clicked = val;
  }

  logout() {
    this.authService.logout();
    // this.router.navigate(["/login"]);
  }

  obtenerDatosUsuario(rut_usu: number) {
    let self = this;
    var bodyx: usuario = new usuario();
    bodyx.rut_usuario = rut_usu;
    this.client.query({
      query: gql`
      query($entidad:usuarioInputType){
        usuario{
          obtenerSegunId(entidad:$entidad){
            respuesta{
              rut_usuario
              login
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      },
      fetchPolicy: 'network-only',
    },
      function (respuesta) {
        self.nombre_usuario = respuesta.data.usuario.obtenerSegunId.respuesta.nombre_completo;
      });
  }

  obtenerUsuarioRol(rut_usu: number) {
    let self = this;
    self.rutUsuario = rut_usu;
    var bodyx: usuario_rol = new usuario_rol();
    bodyx.rut_usuario = self.rutUsuario;
    this.client.query({
      query: gql`
      query($entidad:usuario_rolInputType){
        usuario_rol{
          obtenerSegunId(entidad:$entidad){
            respuesta{
              rut_usuario
              roles_codigo
              fecha_asignacion
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.codigo_rol = respuesta.data.usuario_rol.obtenerSegunId.respuesta.roles_codigo;
      self.obtenerCategoriaModuloOperacion(self.codigo_rol);
    });
  }

  obtenerCategoriaModuloOperacion(codigo_rol: number) {
    let self = this;
    self.client.query({
      query: gql`
      query($codigo_rol:Decimal){
        rol_operacion{
          obtenerMenuxRol(codigo_rol:$codigo_rol){
            respuesta{
              registros{
                categoria_codigo
                categoria_nombre
                icono
                modulo_codigo
                modulo_nombre
                endpoint
                operacion_codigo
                operacion_nombre
                orden_modulo
                rol_codigo
                escabecera
              }
            }
          }
        }
      }
      `,
      variables: {
        "codigo_rol": codigo_rol
      },
      fetchPolicy: 'no-cache',
    },
      function (respuesta) {
        self.moduloMenu = respuesta.data.rol_operacion.obtenerMenuxRol.respuesta.registros;
        self.moduloMenu.sort((a, b) => a.orden_modulo - b.orden_modulo);
        var categoria: any;
        self.moduloMenu.forEach(element => {
          if (element.escabecera == true) {
            categoria = {
              rol_codigo: element.rol_codigo,
              categoria_codigo: element.categoria_codigo,
              categoria_nombre: element.categoria_nombre,
              icono: element.icono,
              modulo_codigo: element.modulo_codigo,
              modulo_nombre: element.modulo_nombre,
              endpoint: element.endpoint,
              operacion_codigo: element.operacion_codigo,
              operacion_nombre: element.operacion_nombre,
              orden_modulo: element.orden_modulo,
              escabecera: element.escabecera
            };
            self.categoriasMenu.push(categoria);
          }
        });
      });
  }


  sendMessage() {
    const inputParams = {
      entidad: {
        tipo_notificacion_codigo: 0,
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
    };
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        //console.log('Mensaje enviado con éxito');
      },
      (error) => {
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }
  eliminarNotificacion(mov: any) {
    const inputParams = {
      entidad: {
        codigo_notificacion: mov.codigo,
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        isEliminarNotificacion: true,
        environment_functions: ENVIRONMENT_FUNCTIONS
      },
    }
    this.signalRMessageService.send(inputParams).subscribe(
      () => {
        //console.log('Mensaje enviado con éxito');
      },
      (error) => {
        console.error('Error al enviar el mensaje:', error);
      }
    );
    // this.toggleMenu();
    //console.error('Elimina notificacion');
  }

  verNotificacion() {
    // this.countNotificaciones = 0;
  }

  closeDropdown() {
    console.log('CERRRAMOS DROPDOWN - NUMERO DE NOTIFICACIONES', this.countNotificaciones)
    if (!this.isMenuOpen) return;

    this.isMenuOpen = false;
    this.actualizarNotificaciones();
    // if(this.countNotificaciones == 0) {
    //   this.toggleMenu();
    //   return;
    // };


    // const inputParams = {
    //   entidad: {
    //     rut_usuario: this.rutUsuario,
    //     rut_empresa: this.rutEmpresa,
    //     sucursal_codigo: this.sucursalCodigo,
    //     isUpdateNotificacion: true,
    //     environment_functions: ENVIRONMENT_FUNCTIONS
    //   },
    // }
    // console.log('LLAMAMOS A MODIFICAR NOTIFICACIONES', inputParams)
    // this.signalRMessageService.send(inputParams).subscribe(
    //   () => {
    //     //console.log('Mensaje enviado con éxito');
    //   },
    //   (error) => {
    //     console.error('Error al enviar el mensaje:', error);
    //   }
    // );
    // this.toggleMenu();
    //console.error('Modificar notificacion');
  }

  DownloadArchivo(rutaArchivo: string, notificacion?: any) {
    // Si es una notificación de tipo 5 (conversión NV a facturas), no descargar archivo
    if (notificacion && notificacion.tipo_notificacion_codigo === 5) {
      this.obtenerFoliosADocumentosGenerados(notificacion);
      return;
    }

    const nombreArchivoLocal = rutaArchivo; // Reemplazar con el nombre deseado del archivo

    this.descargarArchivoService.descargarArchivo(nombreArchivoLocal).subscribe(
      (blobData: Blob) => {
        this.createDownload(blobData, nombreArchivoLocal);
      },
      error => {
        console.error('Error al descargar el archivo:', error);
      }
    );
    this.closeDropdown()
  }

  private actualizarNotificaciones(): void {
    // Cambio: evitamos requests innecesarias cuando ya no hay pendientes.

    console.log('ACTUALIZANDO NOTIFICACIONES - NUM Notificaciones', this.countNotificaciones)
    if (this.countNotificaciones === 0) return;

    const inputParams = {
      entidad: {
        rut_usuario: this.rutUsuario,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        isUpdateNotificacion: true,
        environment_functions: ENVIRONMENT_FUNCTIONS,
      },
    };

    console.log('LLAMAMOS A MODIFICAR NOTIFICACIONES', inputParams)

    // Cambio: envío centralizado para cualquier cierre del dropdown.
    this.signalRMessageService.send(inputParams).subscribe(
      () => { },
      (error) => console.error('Error al enviar el mensaje:', error),
    );
  }

  private createDownload(blobData: Blob, nombreArchivoLocal: string) {
    const blobUrl = window.URL.createObjectURL(blobData);

    // Crear un enlace temporal
    const link = document.createElement('a');
    link.href = blobUrl;
    link.target = '_blank';
    link.download = nombreArchivoLocal;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  }

  private obtenerFoliosADocumentosGenerados(notificacion: any) {
    //folios como string separado por coma y reemplazarlas por array
    const folios = notificacion.folios.split(',');

    //Consultar servicio de resultados de conversion y despues abrir el modal
    const inputParams = {
      folios: folios,
      rut_emisor: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      usuario_rut_usuario: this.rutUsuario,
    }

    this.documentoNoTributarioService.ObtenerFoliosADocumentosGenerados(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.closeDropdown();
        return;
      } else {
        const registros = respuesta.registros || [];
        this.modalResultadosConversionService.mostrarModal(registros);
        this.closeDropdown();
      }
    });
  }
}
